import { render, staticRenderFns } from "./search-stats-minimal.vue?vue&type=template&id=70d4d242&"
import script from "./search-stats-minimal.vue?vue&type=script&lang=js&"
export * from "./search-stats-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports